var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5247 2.27008C11.7841 2.27008 12 2.49617 12 2.78387V3.04987C12 3.33057 11.7841 3.56366 11.5247 3.56366H0.475902C0.215907 3.56366 0 3.33057 0 3.04987V2.78387C0 2.49617 0.215907 2.27008 0.475902 2.27008H2.41971C2.81457 2.27008 3.1582 1.97538 3.24703 1.55958L3.34882 1.08219C3.50702 0.431896 4.02766 0 4.62351 0H7.37649C7.96585 0 8.49233 0.431896 8.64469 1.04789L8.75362 1.55888C8.8418 1.97538 9.18543 2.27008 9.58094 2.27008H11.5247ZM10.5488 11.9933C10.7517 10.0074 11.107 5.28949 11.107 5.24189C11.12 5.0977 11.0753 4.9612 10.9864 4.8513C10.8911 4.7484 10.7705 4.6875 10.6376 4.6875H1.39059C1.25703 4.6875 1.12995 4.7484 1.04177 4.8513C0.952293 4.9612 0.908204 5.0977 0.914687 5.24189C0.915879 5.25064 0.928628 5.41683 0.949943 5.69468C1.04463 6.92896 1.30835 10.3666 1.47877 11.9933C1.59936 13.1917 2.34823 13.9449 3.43295 13.9722C4.26999 13.9925 5.13232 13.9995 6.0141 13.9995C6.84466 13.9995 7.68819 13.9925 8.55117 13.9722C9.67349 13.9519 10.4217 13.212 10.5488 11.9933Z",
    fill: "#EE3031"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.822e8f7635ef9ff8a7e914542f8f09ff.svg";
export { ForwardRef as ReactComponent };